import React from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { Card, CardBody, Col, Container, Row } from "reactstrap"

const firstAttendanceInstructions = [
  "Commit to arriving 30 minutes before the scheduled time.",
  "Entry is prohibited after 20 minutes from the start of training.",
  "Attendance is only permitted at the specified appointment time; no modifications or attendance at different times are allowed.",
  "Absence from practical training will result in permanent cancellation of your job nomination.",
]

const secondInstructions = [
  "Commitment to wearing complete athletic attire (tracksuit + athletic shoes).",
  "Smoking is strictly prohibited within the station premises.",
  "Complete adherence to the instructions of the organization, training, and industrial security teams.",
  "Non-cooperation with the supervising teams is considered a violation that will subject you to immediate dismissal.",
  "Maintain the cleanliness of the station and do not throw waste within the site.",
]

const thirdInstructions = [
  "Your performance will be evaluated during the practical training and is considered part of the job acceptance criteria.",
  "Attendance will be taken twice: first upon entry and second upon departure.",
]

const fourthInstructions = [
  "A different meeting point is determined according to the training location (Arafat 2 or Arafat 3).",
  "You can identify the meeting point through the link attached on the booking page.",
  "Meeting point to reach Arafat 2 station: https://shorturl.at/e2ANG",
  "Meeting point to reach Arafat 3 station: https://shorturl.at/kGghg",
]

const Record = ({ name, value }) => {
  return (
    <Col xs="6" md="2" className="mb-2">
      <div className="font-bold">{name}</div>
      <div>{value}</div>
    </Col>
  )
}

const PracticalTrainingPreview = ({ training }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  const { user_job_title } = useSelector(state => state.JobApplication)

  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col xl="12">
            <h4 className="card-title mb-4">{t("My Practical Training")}</h4>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <h5 className="text-primary">{t("Practical Training")}</h5>
          </Col>
        </Row>

        <Card className="mb-4">
          <CardBody>
            <Row className="text-center">
              <Record name={t("Training Name")} value={training?.name} />
              <Record name={t("Job Title")} value={user_job_title} />
              <Record name={t("Site")} value={training?.site} />
              <Record name={t("Station")} value={training?.station} />
              <Record
                name={t("Date")}
                value={`${training?.start_date} ~ ${training?.end_date}`}
              />
              <Record
                name={t("Time")}
                value={`${training?.start_time} ~ ${training?.end_time}`}
              />
              <Record
                name={t("Attended Days")}
                value={training?.assessment_details?.attended_days}
              />
              <Record
                name={t("Attended Dates")}
                value={training?.assessment_details?.attended_dates?.dates?.join(
                  ", "
                )}
              />
            </Row>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <h6 className="text-primary fw-bold mb-3">
              {t("Practical Training Attendance Instructions")}
            </h6>
            <p>
              {t(
                "We hope you read the following instructions carefully, as adherence to them is a fundamental condition for participation in the practical training:"
              )}
            </p>
            <h6 className="fw-bold mt-4">{t("Attendance and Discipline:")}</h6>
            <ul>
              {firstAttendanceInstructions.map(item => {
                return <li key={item}>{t(item)}</li>
              })}
            </ul>

            <h6 className="fw-bold mt-4">{t("Appearance and Behavior:")}</h6>
            <ul>
              {secondInstructions.map(item => {
                return <li key={item}>{t(item)}</li>
              })}
            </ul>
            <h6 className="fw-bold mt-4">{t("During Training:")}</h6>
            <ul>
              {thirdInstructions.map(item => {
                return <li key={item}>{t(item)}</li>
              })}
            </ul>
            <h6 className="fw-bold mt-4">{t("Meeting Point:")}</h6>
            <ul>
              {fourthInstructions.map(item => {
                return <li key={item}>{t(item)}</li>
              })}
            </ul>

            <p>
              {t(
                "We wish you a rich and fruitful training experience, and we appreciate your adherence to the instructions to ensure the smooth operation of the program."
              )}
            </p>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default PracticalTrainingPreview
